import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, ShieldCheckIcon, WifiIcon, KeyRoundIcon, SmartphoneIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-1709">
      {/* Header with logo */}
      <header className="w-full bg-[#1a0647] px-6 py-4" data-id="element-1710">
        <div className="max-w-4xl mx-auto flex items-center" data-id="element-1711">
          <Link to="/" className="flex-shrink-0" data-id="element-1712">
            <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-5" data-id="element-1713" />
          </Link>
        </div>
      </header>

      {/* Main content */}
      <div className="px-6 pt-6 pb-10" data-id="element-1714">
        <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-1715">
          {/* Heading */}
          <h1 className="md:text-4xl text-[#111111] mb-1 tracking-tight text-[28px] font-[600]" data-id="element-1716">
            Digital Risk Assessment
          </h1>
          <p className="text-gray-500 text-base md:text-lg mb-6" data-id="element-1717">
            Get a personalized plan in 3-4 minutes.
          </p>

          {/* Three-step process */}
          <div className="flex items-center justify-center mb-6" data-id="element-1718">
            <div className="flex flex-col items-center" data-id="element-1719">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1720">
                <ClipboardCheckIcon size={24} className="text-gray-400" data-id="element-1721" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1722">
                Assess
              </span>
            </div>

            <div className="w-10 md:w-16 h-[2px] bg-gray-200 mb-5" data-id="element-1723" />

            <div className="flex flex-col items-center" data-id="element-1724">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1725">
                <BookOpenIcon size={24} className="text-gray-400" data-id="element-1726" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1727">
                Inform
              </span>
            </div>

            <div className="w-10 md:w-16 h-[2px] bg-gray-200 mb-5" data-id="element-1728" />

            <div className="flex flex-col items-center" data-id="element-1729">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1730">
                <ShieldCheckIcon size={24} className="text-gray-400" data-id="element-1731" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1732">
                Secure
              </span>
            </div>
          </div>

          {/* What we'll cover label */}
          <p className="text-[#631bb7] text-base mb-4 font-[500]" data-id="element-1733">
            Here's what we'll cover:
          </p>

          {/* What's Covered */}
          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-1734">
            <div className="flex px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm pt-[8px] pb-[8px] pl-[8px] pr-[8px] items-center justify-center" data-id="element-1735">
              <span className="text-xl flex-shrink-0" data-id="element-1736">🏠</span>
              <span className="ml-2 text-sm text-[#111111] whitespace-nowrap font-[500]" data-id="element-1737">
                Home Network
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1738">
              <span className="text-xl flex-shrink-0" data-id="element-1739">🔐</span>
              <span className="ml-2 text-sm text-[#111111] whitespace-nowrap font-[500]" data-id="element-1740">
                Passwords
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1741">
              <span className="text-xl flex-shrink-0" data-id="element-1742">📱</span>
              <span className="ml-2 text-[#111111] whitespace-nowrap text-[15px] font-[500]" data-id="element-1743">
                Devices
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1744">
              <span className="text-xl flex-shrink-0" data-id="element-1745">🛡️</span>
              <span className="ml-2 text-sm text-[#111111] whitespace-nowrap font-[500]" data-id="element-1746">
                Data & Privacy
              </span>
            </div>
          </div>

          {/* Start Assessment button */}
          <Link to="/assessment" className="bg-[#631bb7] text-white px-6 py-2.5 rounded-lg font-bold text-lg no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-1747">
            Start Assessment
          </Link>
        </div>
      </div>
    </div>;
}